import React, { useState, useEffect } from "react";
import { Container, Row, Button, Col, Image, Form } from "react-bootstrap";
import LeftSideNavigation from "../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../navigationSection/BottomNavigationMobile";
import { TopNavigationBarMobile } from "../navigationSection/TopNavigationBarMobile";
import { SmallRatingReviewReusableComponent } from "../../superAdminComponents/superAdminAllComponent/superAdminRatingReviews/InsidePageComponent/SmallRatingReviewReusableComponent";
import Filter from "./Filter";
import Seating from "./VendorRatingReviewInsidePages/Seating";
import Events from "./VendorRatingReviewInsidePages/Events";
import Orders from "./VendorRatingReviewInsidePages/Orders";
import Items from "./VendorRatingReviewInsidePages/Items";
import Pay from "./VendorRatingReviewInsidePages/Pay";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { clear_all_errors } from "../../../store/actions/errorActions";
import {
  get_all_rating_review,
  get_all_rating_review_count,
} from "../../../store/actions/dashboardAction/vendorRatingReviewAction";
import isEmpty from "../../../store/validation/is-Empty";
import { AmealioLoader } from "../../Loader/AmealioLoader";
import Media from "react-media";

const VendorRatingReviewsComponent = (props) => {
  const [selectedTab, setSelectedTab] = useState("0");
  // const [mobileTab, setMobileTab] = useState("0");
  const handleTab = (e) => {
    setSelectedTab(e);
  };

  // const setTab = (e) => {
  //   setMobileTab(e);
  // }

  useEffect(() => {
    props.get_all_rating_review(
      props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id,
      props.auth.user.accessToken,
      selectedTab
    );
  }, [selectedTab]);

  const [allRatingReview, setAllRatingReview] = useState([]);
  useEffect(() => {
    setAllRatingReview(props.allRatingReview);
  }, [props.allRatingReview]);

  useEffect(() => {
    if (props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id) {
      props.get_all_rating_review_count(
        props?.vendorAccess?.vendor_id || props.auth.user.VendorUser._id,
      );
    }
  }, [props?.auth.user]);

  var msgTotal = allRatingReview.reduce(function (prev, cur) {
    return prev + cur.rating;
  }, 0);
  const averageRating = msgTotal / allRatingReview.length;

  if (props.auth.loader === true) {
    return <AmealioLoader />;
  } else {
    return (
      <React.Fragment>
        <Container fluid className="mobile-css-applicable">
          <Row>
            <Media query="(min-width: 992px)">
              <div className="left-side-panel">
                <LeftSideNavigation />
              </div>
            </Media>

            {/* <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div> */}
            <div className="right-side-panel ">
              <RightSideNavigation
                // leftText="vendorReview"
                // backButtonLink="/seatingdashboard"
                displayText="Vendor Review"
              />
              <div className="super-admin-inside-right-side-panel pt-3 main-seating-dashboard-body">
                <Container fluid className="p-0 row">
                  <Media query="(min-width: 992px)">
                    <Col xs={12} lg={4}>
                      <Row>
                        <Col xs={3} md={12}>
                          <div className="enIMG75">
                            <Image
                              src={
                                props?.onboarding && props?.onboarding?.logo_url
                              }
                              alt="View"
                              title="View"
                              fluid
                              className="w-100 h-100"
                            />
                          </div>
                        </Col>

                        <Col xs={8} md={12}>
                          <div className="f24-500 my-2 ">
                            {props?.onboarding &&
                              props?.onboarding?.restaurant_name}
                          </div>
                          <div className="f14-400">
                            {props?.onboarding &&
                              props?.onboarding?.restaurant_address}
                          </div>
                        </Col>
                      </Row>
                    </Col>
                  </Media>
                  <Media query="(max-width: 992px)">
                    <Container>
                      <Col xs={12} lg={4}>
                        <Row>
                          <Col xs={3} md={12}>
                            <div className="enIMG75">
                              <Image
                                src={
                                  props?.onboarding &&
                                  props?.onboarding?.logo_url
                                }
                                alt="View"
                                title="View"
                                fluid
                                className="w-200 h-100"
                              />
                            </div>
                          </Col>
                          <Col xs={8} md={12}>
                            <div className="f14-500 my-2 ">
                              {props?.onboarding &&
                                props?.onboarding?.restaurant_name}
                            </div>
                            <div className="f10-400">
                              {props?.onboarding &&
                                props?.onboarding?.restaurant_address}
                            </div>
                          </Col>
                        </Row>
                      </Col>
                      <br />
                    </Container>
                  </Media>
                  <Media query="(min-width: 992px)">
                    <Col lg={8} className="mt-4">
                      <Row>
                        <Col lg={12}>
                          <Row className="h-100">
                            <Col
                              md={4}
                              xs={3}
                              className="mobile-min-height-100 h-100 mobile-p-1"
                            >
                              <div className="mobile-min-height-100 small-rating-review-section h-100 d-flex align-items-center justify-content-center ">
                                <div className="text-center">
                                  <Image
                                    fluid
                                    all="Restaurant Rating"
                                    title="Restaurant Rating"
                                    width="30px"
                                    src={require("../../../assets/images/superadmin/star.svg")}
                                  />
                                  <div className="m-f14-500 f36-500">
                                    {props?.allRatingReviewCount &&
                                      props?.allRatingReviewCount
                                        ?.averageRating}{" "}
                                    Stars
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col md={4} xs={3} className="h-100 mobile-p-1">
                              <div className="mobile-min-height-100 small-rating-review-section h-100">
                                <div className="col-12 small-rating-review-sectionone flex-column">
                                  <div className="f16-500 pb-1 m-f10-500">
                                    Total Reviews
                                  </div>
                                  <div className="f10-400 m-f06-400">
                                    Activity from all Time
                                  </div>
                                </div>
                                <div className="col-12 small-rating-review-sectiontwo d-flex align-items-center justify-content-center">
                                  <div className="f28-500 pt-4">
                                    {props?.allRatingReviewCount &&
                                      props?.allRatingReviewCount?.totalReviews}
                                  </div>
                                </div>
                              </div>
                            </Col>
                            <Col lg={4} xs={6} className="ratings-bar">
                              <SmallRatingReviewReusableComponent
                                fiveStar={
                                  props?.allRatingReviewCount &&
                                  props?.allRatingReviewCount?.rating_5start
                                }
                                fourStar={
                                  props?.allRatingReviewCount &&
                                  props?.allRatingReviewCount?.rating_4start
                                }
                                threeStar={
                                  props?.allRatingReviewCount &&
                                  props?.allRatingReviewCount?.rating_3start
                                }
                                twoStar={
                                  props?.allRatingReviewCount &&
                                  props?.allRatingReviewCount?.rating_2start
                                }
                                oneStar={
                                  props?.allRatingReviewCount &&
                                  props?.allRatingReviewCount?.rating_1start
                                }
                                progressBar="main-progress-bar-sectiontwo"
                              />
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                    </Col>
                  </Media>
                  <Media query="(max-width: 992px)">
                    <Container>
                      <Col lg={8} className="">
                        <Row>
                          <Col lg={12}>
                            <Row className="h-100">
                              <Col md={4} xs={3} className="h-500 mobile-p-1">
                                <div className="mobile-min-height-100  small-rating-review-section h-100 d-flex align-items-center justify-content-center ">
                                  <div className="text-center">
                                    <Image
                                      fluid
                                      all="Restaurant Rating"
                                      title="Restaurant Rating"
                                      width="30px"
                                      src={require("../../../assets/images/superadmin/star.svg")}
                                    />
                                    <div className="m-f14-500 f36-500">
                                      {props?.allRatingReviewCount &&
                                        props?.allRatingReviewCount
                                          ?.averageRating}{" "}
                                      Stars
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col md={4} xs={3} className="h-500 mobile-p-1">
                                <div className=" mobile-min-height-100 small-rating-review-section h-100">
                                  <div className="col-12 small-rating-review-sectionone flex-column">
                                    <div className="f14-500 pb-1 pt-200 m-f10-500">
                                      Total Reviews
                                    </div>
                                    <div className="f10-500 m-f06-400">
                                      Activity from all Time
                                    </div>
                                  </div>
                                  <div className="col-12 small-rating-review-sectiontwo d-flex align-items-center justify-content-center">
                                    <div className="f28-500 pt-4">
                                      {props?.allRatingReviewCount &&
                                        props?.allRatingReviewCount
                                          ?.totalReviews}
                                    </div>
                                  </div>
                                </div>
                              </Col>
                              <Col lg={4} xs={6} className="ratings-bar">
                                <SmallRatingReviewReusableComponent
                                  fiveStar={
                                    props?.allRatingReviewCount &&
                                    props?.allRatingReviewCount?.rating_5start
                                  }
                                  fourStar={
                                    props?.allRatingReviewCount &&
                                    props?.allRatingReviewCount?.rating_4start
                                  }
                                  threeStar={
                                    props?.allRatingReviewCount &&
                                    props?.allRatingReviewCount?.rating_3start
                                  }
                                  twoStar={
                                    props?.allRatingReviewCount &&
                                    props?.allRatingReviewCount?.rating_2start
                                  }
                                  oneStar={
                                    props?.allRatingReviewCount &&
                                    props?.allRatingReviewCount?.rating_1start
                                  }
                                  progressBar="main-progress-bar-sectiontwo"
                                />
                              </Col>
                            </Row>
                          </Col>
                        </Row>
                      </Col>
                    </Container>
                  </Media>

                  <Col md={12} className="margin-bottom-150px">
                    <hr />
                    <Media query="(min-width: 992px)">
                      <div className="enTabs d-flex flex-wrap align-items-center mt-4 mb-2 position-relative">
                        <Button
                          onClick={(e) => handleTab("0")}
                          className={`${selectedTab === "0" ? "active" : ""}`}
                        >
                          General
                        </Button>
                        <Button
                          onClick={(e) => handleTab("1")}
                          className={`${selectedTab === "1" ? "active" : ""}`}
                        >
                          Seating
                        </Button>
                        <Button
                          onClick={(e) => handleTab("6")}
                          className={`${selectedTab === "6" ? "active" : ""}`}
                        >
                       Experience
                        </Button>
                        <Button
                          onClick={(e) => handleTab("3")}
                          className={`${selectedTab === "3" ? "active" : ""}`}
                        >
                          Orders
                        </Button>
                        <Button
                          onClick={(e) => handleTab("4")}
                          className={`${selectedTab === "4" ? "active" : ""}`}
                        >
                          Items
                        </Button>
                        <Button
                          onClick={(e) => handleTab("5")}
                          className={`${selectedTab === "5" ? "active" : ""}`}
                        >
                          Pay
                        </Button>
                        <div
                          className="bg-white p-2 text-center position-absolute mt-4"
                          style={{
                            width: "10%",
                            right: 0,
                            boxShadow: "0px 3px 6px #00000019",
                          }}
                        >
                          <p className="f10-500">
                            {selectedTab === "0"
                              ? "General Ratings"
                              : selectedTab === "1"
                                ? "Seating Ratings"
                                : selectedTab === "2"
                                  ? "Events Ratings"
                                  : selectedTab === "3"
                                    ? "Orders Ratings"
                                    : selectedTab === "4"
                                      ? "Items Ratings"
                                      : "Scan & Pay Ratings"}
                          </p>
                          <hr />
                          <div className="col-12 mb-2">
                            <Image
                              fluid
                              all="Restaurant Rating"
                              title="Restaurant Rating"
                              width="20px"
                              src={require("../../../assets/images/superadmin/star.svg")}
                            />
                          </div>
                          <span className="f12-500">
                            {isNaN(averageRating) === true
                              ? "0"
                              : averageRating.toFixed(2)}{" "}
                            Stars
                          </span>
                        </div>
                      </div>
                    </Media>
                    <Media query="(max-width: 992px)">
                      <div class="nav-scroller py-1 h-auto">
                        <div className="nav d-flex align-items-center pb-0">
                          <Button
                            variant="link"
                            className={`px-0 mr-3 text-grayLink f9-400 notify_text ${selectedTab === "0" ? "active" : ""
                              }`}
                            onClick={(e) => handleTab("0")}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            General
                          </Button>
                          <Button
                            variant="link"
                            className={`px-0 mr-3 text-grayLink f9-400 notify_text ${selectedTab === "1" ? "active" : ""
                              }`}
                            onClick={(e) => handleTab("1")}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Seating
                          </Button>
                          <Button
                            variant="link"
                            className={`px-0 mr-3 text-grayLink f9-400 notify_text ${selectedTab === "2" ? "active" : ""
                              }`}
                            onClick={(e) => handleTab("2")}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Events
                          </Button>
                          <Button
                            variant="link"
                            className={`px-0 mr-3 text-grayLink f9-400 notify_text ${selectedTab === "3" ? "active" : ""
                              }`}
                            onClick={(e) => handleTab("3")}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Orders
                          </Button>
                          <Button
                            variant="link"
                            className={`px-0 mr-3 text-grayLink f9-400 notify_text ${selectedTab === "4" ? "active" : ""
                              }`}
                            onClick={(e) => handleTab("4")}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Items
                          </Button>
                          <Button
                            variant="link"
                            className={`px-0 mr-2 text-grayLink f9-400 notify_text ${selectedTab === "5" ? "active" : ""
                              }`}
                            onClick={(e) => handleTab("5")}
                            style={{ fontSize: "12px", fontWeight: "bold" }}
                          >
                            Pay
                          </Button>
                        </div>
                      </div>
                    </Media>
                    {selectedTab === "0" && (
                      <Seating
                        seatingReview={allRatingReview}
                        selectedValue={selectedTab}
                      />
                    )}
                    {selectedTab === "1" && (
                      <Seating
                        seatingReview={allRatingReview}
                        selectedValue={selectedTab}
                      />
                    )}
                    {selectedTab === "6" && (
                      <Events
                        seatingReview={allRatingReview}
                        selectedValue={selectedTab}
                      />
                    )}
                    {selectedTab === "4" && (
                      <Items
                        seatingReview={allRatingReview}
                        selectedValue={selectedTab}
                      />
                    )}
                    {selectedTab === "3" && (
                      <Seating
                        seatingReview={allRatingReview}
                        selectedValue={selectedTab}
                      />
                    )}
                    {selectedTab === "5" && (
                      <Pay
                        seatingReview={allRatingReview}
                        selectedValue={selectedTab}
                      />
                    )}
                  </Col>
                </Container>
              </div>
            </div>
            <Media query="(max-width: 991px)">
              <div className="bottom-panel">
                <BottomNavigationMobile />
              </div>
            </Media>
          </Row>
        </Container>
      </React.Fragment>
    );
  }
};
// export default VendorRatingReviewsComponent;
VendorRatingReviewsComponent.propTypes = {
  auth: PropTypes.object.isRequired,
  errors: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  allRatingReview: state.vendorRatingReviews.vendor_get_all_rating_review,
  allRatingReviewCount:
    state.vendorRatingReviews.vendor_get_all_rating_review_count,
  onboarding: state.onboarding.restaurantDetails,
  auth: state.auth,
  errors: state.errors.errors,
  vendorAccess: state.vendorAccess
});

export default connect(mapStateToProps, {
  clear_all_errors,
  get_all_rating_review,
  get_all_rating_review_count,
})(withRouter(VendorRatingReviewsComponent));
